import {QueryHelpNavItem} from './types';

export const QUERY_HELP_NAV_ITEMS: QueryHelpNavItem[] = [
    {id: 'simple', label: 'Simple examples', description: 'Keywords, phrases, and exclusions'},
    {id: 'syntax', label: 'Query syntax', description: 'Operators, fields, and mistakes'},
    {id: 'samples', label: 'Query examples', description: 'Fields, wildcards, and fuzzy search'},
    {id: 'complex', label: 'Advanced examples', description: 'Groups, dates, boosts, and fields'},
    {id: 'production', label: 'Production patterns', description: 'Templates, checklists, and tips'},
    {id: 'sales', label: 'Sales examples', description: 'Intent, objections, and retention'},
];

export const QUERY_HELP_PAGE_INTROS: Record<string, string> = {
    simple: 'Try these common searches or explore other sections for more.',
    syntax: 'Reference for operators, defaults, and common syntax mistakes.',
    samples: 'Practical examples with explanations of what each query matches.',
    complex: 'Boolean grouping and multi-concept queries.',
    production: 'How large real-world queries are structured: phrase banks, exclusions, and templates abstracted from production usage.',
    sales: 'Queries for finding sales intent, offers, objections, closes, and retention moments in customer conversations.',
};
